import { cn } from './cn.js'
import { us } from './us.js'

export const translationsObject = {
    cn: cn,
    us: us
}
